import { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";

export default function Login() {
  const [name, setName] = useState("");
    const [isPass, setIsPass] = useState(true);

  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if(!name){
        toast.error("Enter user name.")
        return;
    }
    
    if(password === 'maplecloud@123'){
        navigate('/reviews')
    }else{
        toast.error('Wrong password !')
       
    }
  };

  

  return (
            <div className="h-screen w-full inset-0 flex items-center justify-center bg-black/60 z-50">
      <Toaster position="top-right" reverseOrder={false} />

    <div className="w-full max-w-md bg-[#131A27] border border-[#1F2737] rounded-2xl shadow-2xl p-8 hover:shadow-cyan-500/20 transition-shadow duration-300">

        {/* Header */}
        <h2 className="text-center text-3xl font-bold text-white mb-1 tracking-wide drop-shadow-md">
          Admin Login
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8">
          Access panel for review approval
        </p>

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-5">

          {/* Name Field */}
          <div>
            <label className="text-gray-300 text-sm">Name</label>
            <input
              type="text"
              className="w-full mt-1 px-4 py-3 bg-[#0D121C] border border-[#1F2737] rounded-xl text-white focus:outline-none focus:border-cyan-500 transition"
              placeholder="Enter username"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          {/* Password Field */}
          <div className="relative">
            <label className="text-gray-300 text-sm">Password</label>
            <input
                  type={isPass ? "password" : "text"}
              className="w-full mt-1 px-4 py-3 bg-[#0D121C] border border-[#1F2737] rounded-xl text-white focus:outline-none focus:border-cyan-500 transition"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {isPass ? (
                  <FaRegEyeSlash
                    onClick={() => setIsPass(false)}
                    className="absolute top-12 text-white  right-4 cursor-pointer"
                  />
                ) : (
                  <FaRegEye
                    onClick={() => setIsPass(true)}
                    className="absolute top-12 text-white right-4 cursor-pointer"
                  />
                )}
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 pt-2">
            {/* Cancel Button */}
            {/* <button
              type="button"
              onClick={onCancel}
              className="w-1/2 py-3 rounded-xl bg-[#1E2738] border border-[#2A3447] text-gray-300 hover:text-white hover:bg-[#263148] transition font-medium"
            >
              Cancel
            </button> */}

            {/* Login Button */}
            <button
              type="submit"
              className="w-full py-3 rounded-xl bg-cyan-600 transition text-white font-semibold tracking-wide shadow-lg "
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
